export { contactsManifest } from "./contacts-manifest";
